import {IEnvironment, PAGE_HEADERS} from '../ienvironment';

export const getPaidBaseEnvironment: IEnvironment = {
    production: false,
    name: 'STAGING',
    reconFileDownloadable: new Date(2020, 3, 5),
    recaptcha: {
        siteKey: '6LeXSgQkAAAAALgds9k8KDnAuCyDiylqtyhz23YS'
    },
    instanceName: 'GetPaid',
    assetSubDirectory: 'getPaid-styles',
    logoMain: 'main-logo.png',
    logoMobile: 'main-logo-mobile.png',
    logoSecondary: 'secondary-logo.png',
    domainUrl: 'https://staging-getpaid.mymoneymarket.co.za',
    privacyNoticeLink: '',
    serviceTermsLink: 'https://www.termsconditions.co.za/content/dam/ShopriteGroup/Terms/PDFS/Get-Paid.pdf',
    gatewayMerchantTermsLink: '',
    generalTermsLink: '',
    privacyNoticeLabel: 'Privacy Notice',
    serviceTermsLabel: 'Service Terms & Conditions',
    gatewayMerchantTermsLabel: '',
    swaggerMerchantAPILink: '/yapi/swagger-ui/index.html?urls.primaryName=merchant',
    setupGuideLink: '/yapi/guides/setup-guide.html',
    walkThroughLink: null,
    getHelpModalText: 'You\'ll be directed to our platform partner, Pay@. Don\'t worry, they\'re part of the team and here to help!',
    supportPortalUrl: 'https://support.payat.co.za/',
    domainVerificationSla: '48 hours',
    inAppInstanceLogoPaddingClass: '',
    contentHeaderLogoWidth: 124,
    eCommerceEnabled: true,
    signupSuccessModalTag: 'getpaid-signup-success',
    floatTopUpBankDetails: {
        bankName: 'Nedbank',
        accountNumber: '1219578487',
        branchCode: '198765'
    },
    getPageHeaders(): { [key in PAGE_HEADERS]: string }
    {
        return {
            ACCOUNT_SETTINGS: 'Account Settings',
            USERS: 'Users',
            USER_INVITATIONS: 'User Invitations',
            USER_INVITATION: 'User Invitation',
            USER_EDIT: 'Edit User',
            INVOICES: 'Invoices',
            QUICK_PAY: 'Quick Pay',
            SEND_QUICK_PAY: 'Send Quick Pay',
            CREATE_INVOICE: 'Create an Invoice',
            REQUEST_TO_PAY_TRANSACTION: 'Request to Pay Transaction',
            SEND_REQUEST_TO_PAY_TRANSACTION: 'Send Request to Pay Transaction',
            REQUEST_TO_PAY_TRANSACTION_EDIT: 'Edit Request to Pay Transaction',
            REQUEST_TO_PAY_DETAILS: 'Payment',
            UPLOAD_BULK_FILE: 'Upload Bulk File',
            INDIVIDUAL_DASHBOARD: 'Request to Pay Dashboard',
            ECOMMERCE_DASHBOARD: 'E-Commerce Dashboard',
            REFUND_DASHBOARD: 'Refund Dashboard',
            FLOAT_MONITORING: 'Float Monitoring',
            ECOMMERCE_TRANSACTIONS: 'E-Commerce Transactions',
            ECOMMERCE_LANDING: 'Welcome to GetPaid',
            ECOMMERCE_KYC: 'Verify Your Business',
            REFUND_TRANSACTIONS: 'Refund Transactions',
            BULK_DASHBOARD: 'Bulk Dashboard',
            QR_CODES_DASHBOARD: 'QR Codes',
            QR_PAYMENTS_DASHBOARD: 'QR Payments',
            QR_CODE_DETAILS: 'QR Code Details',
            QR_CODE_EDIT: 'Edit QR Code',
            QR_CODE_CREATE: 'Create QR Code',
            SETTLEMENT: 'Settlement',
            SETTLEMENT_BATCH: 'Settlement Batch',
            PURCHASE: 'Purchase Bundles',
            WALKTHROUGH_HEADER: 'Hi!',
            FEES: 'Fees'
        };
    }
};
